import React, { Component } from "react";

class Card extends Component {
  render() {
    const { card, selection, ...flipProps } = this.props;
    const selectedTerms = [selection.primary, ...selection.secondary];
    const bg = card.bg;
    const videoUrl = card.video ? card.video['url'] : false;

    const joinTerms = (list, term) => {
      const style = selectedTerms.includes(term)
        ? { fontWeight: "bold", textDecoration: "underline" }
        : {};
      const tag = (
        <span key={term} style={style}>
          {term}
        </span>
      );
      return list ? [list, ", ", tag] : [tag];
    };

    const debugTerms = card.terms.sort().reduce(joinTerms, null);

    const debugBlock = (
      <div className="debug">
        {debugTerms}
        <br />
        <span style={{ color: "blue" }}>
          {JSON.stringify(card.order, null, 2)}
        </span>
      </div>
    );

    /**
     * These are here because React was double-escaping character entities
     * https://shripadk.github.io/react/docs/jsx-gotchas.html#html-entities
     */
    const cardTitle = {
      __html:
        card.type === "project" && card.client.length
          ? card.client.map(client => client.name).join(", ")
          : card.title
    };

    const cardDesc = {
      __html:
        card.type === "project"
          ? card.title
          : card.excerpt.replace(/^<p>(.*)<\/p>$/gim, "$1")
    };

    /**
     * Set cards media markup, depending on whether a Featured Video field exists.
     */
    const cardImage = {
      __html: `<div class="card__image" style='background-image:url(${card.bg})' />`
    }

    const cardVideo = {
      __html: `<div class="card__video">
          <video autoplay loop muted playsinline>
              <source src="${videoUrl}" type="video/mp4">
          </video>
      </div>`
    }

    const cardMedia = videoUrl ? cardVideo : cardImage;

    return (
      <a
        className="card col-12 col-md-6 js--all-grid-items js-ga-track"
        data-ga-action="Card"
        href={card.link}
        {...flipProps}
      >
        <div className="card__media-container" dangerouslySetInnerHTML={cardMedia} />
        <div className="card__details">
          <h4 className="card__title" dangerouslySetInnerHTML={cardTitle} />
          <h5 className="card__desc" dangerouslySetInnerHTML={cardDesc} />
        </div>
        {/* {debugBlock} */}
      </a>
    );
  }
}

export default Card;
